import { track } from "@/lib/analytics";

// Bundle E-4: shown under the email field when the server flags a likely typo or an unknown mail server.
export default function EmailSuggestion({ hint, onUse, onKeep, submitting }) {
  if (!hint) return null;
  const btn = { fontFamily: "'Manrope', sans-serif", borderRadius: "4px" };
  return (
    <div className="px-3.5 py-3 text-sm space-y-2" style={{ fontFamily: "'Manrope', sans-serif", background: "#12121A", border: "1px solid #2A2A36", borderRadius: "4px", color: "#CBD5E1" }} data-testid="email-suggestion">
      <div data-testid="email-suggestion-text">
        {hint.suggestion ? (<>Did you mean <span className="font-semibold" style={{ color: "#F8FAFC" }}>{hint.suggestion}</span>?</>) : hint.message}
      </div>
      <div className="flex gap-2">
        {hint.suggestion && (
          <button type="button" disabled={submitting} onClick={() => { track("signup_email_suggestion_used"); onUse(hint.suggestion); }}
            className="px-3 py-1.5 text-xs font-semibold disabled:opacity-50" style={{ ...btn, background: "#A855F7", color: "#fff" }} data-testid="email-suggestion-use">Use this</button>
        )}
        <button type="button" disabled={submitting} onClick={onKeep}
          className="px-3 py-1.5 text-xs disabled:opacity-50" style={{ ...btn, border: "1px solid #2A2A36", color: "#CBD5E1" }} data-testid="email-suggestion-keep">Keep what I typed</button>
      </div>
    </div>
  );
}
